import {
  useCallback,
  useEffect,
  useState,
} from 'react';

import useConnectWallet from '@/store/wallet/useConnectWallet';

/**
 * 自定义 Hook：获取指定 EVM 钱包地址的 ERC20 代币余额
 * @returns {Object} 包含代币余额、加载状态和刷新余额的方法
 */
const useGetTokenBalance = () => {
  // 从钱包连接 Hook 获取当前地址和 ERC20 合约实例
  const { address, contractEvm: { TokenErc20 } } = useConnectWallet('evm')
  // 代币余额状态，初始为 0（BigInt 类型）
  const [tokenBalance, setTokenBalance] = useState(BigInt(0))
  // 加载状态，初始为 false
  const [tokenBalanceLod, setLoading] = useState(false)

  /**
   * 获取当前地址的代币余额
   * 使用 useCallback 保证依赖变化时才重新创建
   */
  const getTokenBalance = useCallback(async () => {
    setLoading(true) // 开始加载
    try {
      // 确保地址和合约实例存在
      if (address && TokenErc20) {
        // 调用合约的 balanceOf 方法获取余额
        const balance = await TokenErc20.balanceOf(address)
        setTokenBalance(balance) // 更新余额状态
      }
    } catch (error) {
      // 捕获并打印错误
      console.log("Error fetching token balance:", error)
    }
    setLoading(false) // 加载结束
  }, [address, TokenErc20])

  // 当地址或合约实例变化时自动获取余额
  useEffect(() => {
    getTokenBalance()
  }, [getTokenBalance])

  // 返回余额、加载状态和刷新余额的方法
  return {
    tokenBalance,
    getTokenBalance,
    tokenBalanceLod,
  }
}

export default useGetTokenBalance